// DetailsModal.js
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import HttpClient from '../../utils/HttpClient';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const format1 = "DD-MM-YYYY, h:mm a"

Modal.setAppElement('#root'); // Set the root element for accessibility



const DetailsModal = ({ isOpen, closeModal, details }) => {

    

    const [tableData, setTableData] = useState([]);
    const [BcryptPassword, setBcryptPassword] = useState("")
    const navigate = useNavigate()

    const handleClickid = (id) => {
        navigate('/recently-added-user', { state: id })
    }

    // fetch Category DAta
    const getCategoryData = async () => {
        // setIsLoading(true);

        const res = await HttpClient.requestData('single-user/' + details, 'GET', {});
        if (res && res?.status) {
            const token = res?.data?.[0]?.token
            const decoded = jwtDecode(token);
            setTableData(res?.data);
            setBcryptPassword(decoded?.password)
        }
    }
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = tableData?.[0]?.qrCode;
        link.download = tableData?.[0]?.qrCode;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    useEffect(() => {
        getCategoryData();
    }, [details]);
    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Details Modal"
            className=""
        >
            <a href='#' className='mtclose' onClick={closeModal}><i className="fa-solid fa-xmark"></i></a>


            <>
                <div className=' container'>
                    <div className=' row '>
                        <div className='col-12 d-flex justify-content-center '>
                            <h2 className='  border-bottom border-danger mb-3'>User Details</h2>

                        </div>
                        <hr />
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Customer code:</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.SLNo || "N/A"}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Date & Time Created :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1)}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Member Type :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.upgradeStatus ? "Upgraded Member" : "Member"}</p>
                        </div>
                        {tableData?.[0]?.upgradeDate && <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Upgraded Date & Time  :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.upgradeDate).format(format1)}</p>
                        </div>}
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Company Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.companyName}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Type Of Company</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.TypeOfCompany}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Owner Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.personName}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Reward Points :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.rewardPoints}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Directory count :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.directoryCount}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Designation :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.designation}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Service Type :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.service.map((item, i) => { return (<>&nbsp;<span key={i}>{item}</span>&nbsp;,</>) })}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4' >Email :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.emailId}</p>
                        </div>

                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Telephone :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-solid fa-phone"></i>{tableData?.[0]?.phone_code} - {tableData?.[0]?.telephoneNo}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Mobile No. :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-solid fa-mobile-screen-button"></i>{tableData?.[0]?.phone_code} - {tableData?.[0]?.mobileNo}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Whatsapp :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-brands fa-whatsapp"></i>{tableData?.[0]?.whats_code} - {tableData?.[0]?.whatsappNo}</p>
                        </div>

                        <div className='col-12 d-flex mt-3 '>
                            <h4 className='item-description col-4'>Website :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><a href={tableData?.[0]?.websiteLink} style={{ textDecoration: "underline", cursor: "pointer" }} target="_blank">{tableData?.[0]?.websiteLink}</a></p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Address :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.address} , ({tableData?.[0]?.location})</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Emirate :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.emirate} </p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Country :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.country} </p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Profile Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.userName}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Password :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.passwordView}</p>
                            {/* <p className='mt-1'>{BcryptPassword}</p> */}
                        </div>
                        
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Important Links :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <a href={tableData?.[0]?.dribbbleLink} target="_blank" rel="noopener noreferrer" download=""><p className='mt-1'> <i className="fa-brands fa-square-x-twitter"></i> {tableData?.[0]?.dribbbleLink}</p></a> <br />

                        </div>
                        <div className='col-12' style={{ marginLeft: "380px" }}>
                            <a href={tableData?.[0]?.facebookLink} target="_blank" rel="noopener noreferrer" download=""><p className='mt-1'><i className="fa-brands fa-facebook"></i> {tableData?.[0]?.facebookLink}</p></a>
                            <a href={tableData?.[0]?.instaLink} target="_blank" rel="noopener noreferrer" download=""><p className='mt-1'><i className="fa-brands fa-instagram"></i> {tableData?.[0]?.instaLink}</p></a>
                            <a href={tableData?.[0]?.linkedInLink} target="_blank" rel="noopener noreferrer" download=""> <p className='mt-1'><i className="fa-brands fa-linkedin"></i> {tableData?.[0]?.linkedInLink}</p></a>
                            <a href={tableData?.[0]?.youtubeLink} target="_blank" rel="noopener noreferrer" download=""> <p className='mt-1'><i className="fa-brands fa-youtube"></i> {tableData?.[0]?.youtubeLink}</p></a>

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Banner :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.banner} alt="" id='preview'
                            style={{
                                maxHeight:"128px",
                            }}
                         />

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Profile Photo :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.profilePhoto} alt="" id='preview'
                            style={{
                                maxHeight:"128px",
                            }}
                            />

                        </div>
                        <div className='col-12 d-flex mt-3 mb-4'>
                            <h4 className='item-description col-4'>Product Details :</h4>
                            &nbsp;&nbsp;&nbsp;
                            {tableData?.[0]?.productData?.length > 0 ? tableData?.[0]?.productData?.map((item, i) => {
                                return (
                                    <div className='col-4 mx-3 border rounded '>
                                        <div className=' col-12'>
                                            <div className=' d-flex justify-content-between '>
                                                <div className='mt-2'>
                                                    <h5 style={{ textDecoration: "underline" }}>Product name</h5>
                                                    <p className='mt-1 mx-2 col-12' style={{ color: "#2257B5" }}>{item?.name}&nbsp;&nbsp;</p>
                                                    <br />
                                                </div>
                                                <div className='mt-2 bg-warning h-25 d-flex justify-content-center rounded'
                                                    style={{ width: "20px" }}>
                                                    {i + 1}
                                                </div>
                                            </div>
                                            <div>
                                                <h5 style={{ textDecoration: "underline" }}>Product Description</h5>
                                                <p className='mt-1 mx-2 col-12' style={{ color: "#2257B5" }}>{item?.description}&nbsp;&nbsp;</p>
                                                <br />
                                            </div>
                                            <div>
                                                <h5 style={{ textDecoration: "underline" }}>Product Image</h5>
                                                <img src={item?.image} alt="" id='preview' height="100px" width="100px" className='mb-2 mx-2 col-5' />
                                                <br />
                                            </div>
                                        </div>



                                    </div>
                                )
                            }) : "No Product Found"}
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Product Documents :</h4>
                            &nbsp;&nbsp;&nbsp;
                            {tableData?.[0]?.doc?.length > 0 ? tableData?.[0]?.doc?.map((item, i) => {
                                return (
                                    <div className='col-4  ' style={{ width: "10px" }}>
                                        <div className='col-12 mt-2 mb-2 w-50'>
                                            <h5>{item?.docName}</h5>
                                            <a href={item?.pdf} target="_blank" rel="noopener noreferrer" download="" className=' text-primary mt-2'>
                                                Open PDF <i className="fa-solid fa-download"></i>
                                            </a>
                                            {/* <p className='mt-1'>{item?.pdf}&nbsp;&nbsp;</p> */}
                                        </div>



                                    </div>
                                )
                            }) : "No Document Found"}
                        </div>
                        <div className='col-12 d-grid mt-3'>
                            <div className=" d-flex ">
                                <h4 className='item-description col-4 mt-5'>QR image :</h4>
                                &nbsp;&nbsp;&nbsp;
                                <img src={tableData?.[0]?.qrCode} alt="" id='preview' height="150px" width="150px" />

                            </div>
                            <div style={{ fontSize: "50px", marginLeft: "430px", cursor: "pointer" }}
                            >
                                <i className="fa-solid fa-circle-down" onClick={() => handleDownload()}></i>
                            </div>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>User Link :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <div rel="noopener noreferrer" download=""><p className='mt-1'> <i className="fa-solid fa-basketball"></i> {tableData?.[0]?.userLink}</p></div> <br />
                            <div onClick={() => handleClickid(tableData?.[0]?._id)} target="_blank"><i className="fa-solid fa-diamond-turn-right  mx-2" style={{ color: "#ed0202", fontSize: "30px", cursor: "pointer" }} title="Redirect to the Profile"></i></div>
                        </div>
                          <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Profile URL:</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{`${process.env.REACT_APP_APPLICATION_URL}/profile/${tableData?.[0]?.userName}`}</p>
                        </div>
                    </div>
                </div>
            </>


        </Modal >

    );
};

export default DetailsModal;
